import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated } from './services/auth';
import Login from './components/Login';
import Registrations from './components/Registrations';
import RegistrationDetail from './components/RegistrationDetail';

const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/registrations"
          element={
            <PrivateRoute>
              <Registrations />
            </PrivateRoute>
          }
        />
        <Route
          path="/registrations/:id"
          element={
            <PrivateRoute>
              <RegistrationDetail />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/registrations" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;